import React from 'react';
import ReportBox from "./ReportBox";

const ReportProductSeries = () => {
    return (
        <div>
            <ReportBox pageName="productSeries" apiAddress="ProductSeries/Report" title="گزارش سری تولید"/>

        </div>
    );
};

export default ReportProductSeries;